import { useContext, useEffect, useRef, useState } from "react";
import GeneralContext from "../../../../context/GeneralContext/GeneralContext";
import api from "../../../../services/api";
import { displayMessage } from '../../../../helpers/messages'
import SL_Button from "../../../../components/buttons/Button";
import { SL_Input } from "../../../../components/input/Input";
import { Checkbox, Form, message, Modal, Skeleton } from "antd";
import EContentTypes from "../../../../enums/EContentTypes";
import { SL_Select } from "../../../../components/selects/Select";
import { SL_Upload } from "../../../../components/upload/Upload";
import { UploadOutlined } from "@ant-design/icons";
import { SL_HtmlEditor } from "../../../../components/htmlEditor/HtmlEditor";
import { useParams } from "react-router-dom";
import { ERegExp } from '../../../../enums/ERegExp'

export async function formatImageBeforeSend(originalObj, user_id) {
    try {
        let valuesToFormat = { ...originalObj }
        const file = valuesToFormat?.image?.file?.originFileObj
        if (!file) {
            return null
        }
        const formData = new FormData()
        formData.append("files", file)
        formData.append("user_id", user_id)

        const { data } = await api.attachments.createForContent(formData)
        if (!data?.attachments || data.attachments.length <= 0) {
            return null
        }

        valuesToFormat.image_id = data.attachments[0].id
        delete valuesToFormat?.image

        return valuesToFormat
    } catch (error) {
        console.error(error)        
    }
}

export function CreateContentModal({ onCloseModal, loadContent }) {
    const { idDay } = useParams()
    const editorRef = useRef()

    const [categories, setCategories] = useState([])
    const [subcategories, setSubategories] = useState([])
    const [originalCategories, setOriginalCategories] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [form] = Form.useForm()

    const { setShowLoading, mobile_mode, loggedUser } = useContext(GeneralContext)

    const type = Form.useWatch("type", form)

    useEffect(() => {
        form.setFieldsValue({
            image: null,
            video_url: ''
        })
    }, [type])

    useEffect(() => {
        setTimeout(() => {
            loadData()
        }, 500)
    }, [])

    async function loadData() {
        try {
            const { data } = await api.categories.list()
            let formatedCategories = data?.map(({ id, description }) => ({ value: id, label: description })) ?? []
            setOriginalCategories(data)
            setCategories(formatedCategories)
            setSubategories([])
        } finally {
            setIsLoading(false)
        }
    }

    async function formatValuesBeforeSend(values) {
        let valuesToFormat = { ...values }
        
        if (valuesToFormat.type == EContentTypes.TEXT.value) {
            valuesToFormat.text = editorRef.current.getEditorInnerText()
            valuesToFormat.html_text = editorRef.current.getEditorInnerHTML()
        } else if (valuesToFormat.type == EContentTypes.IMAGE.value) {
            valuesToFormat = await formatImageBeforeSend(valuesToFormat, loggedUser?.id)
        }

        return valuesToFormat
    }

    async function onFinishForm(values) {
        const formattedValues = await formatValuesBeforeSend(values)

        if (!formattedValues) {
            alert('Erro ao formatar conteúdo. ', 'error', 'ERROR')
            return
        }

        try {
            setShowLoading(true)

            await api.content.create(formattedValues)

            await loadContent()

            await onCloseModal(true)
        } finally {
            setShowLoading(false)
        }
    }

    const onCategoryChange = value => {
        const selectedCategory = originalCategories?.find(a => a.id == value)
        if (selectedCategory?.subcategories?.length) {
            let formatedSubategories = selectedCategory?.subcategories?.map(({ id, description }) => ({ value: id, label: description })) ?? []

            setSubategories(formatedSubategories)
            form.setFieldsValue({ subcategory_id: null }); 
        } else {
            setSubategories([])
            form.setFieldsValue({ subcategory_id: null });
        }
    }
    
    return (
        <Modal
            title={<div className="text-xl font-bold text-fit-red-900 mr-3">{displayMessage('ADD_CONTENT_2')}</div>}
            open={true}
            onCancel={() => onCloseModal(false)}
            centered={true}
            footer={
                <div className='flex flex-col ss:flex-row gap-2 justify-end'>
                    <SL_Button className="w-full ss:w-[150px] bg-gray-500 border-transparent" onClick={() => onCloseModal(false)}>{displayMessage('CLOSE')}</SL_Button>

                    <SL_Button className="w-full ss:w-[150px] m-0" onClick={() => form.submit()}>{displayMessage('END_REGISTER')}</SL_Button>
                </div>
            }
            maskClosable={false}
            width={750}
        >
            <Form
                onFinish={onFinishForm}
                layout="vertical"
                form={form}
                className={`flex gap-2 flex-col`}
            >
                {
                    isLoading ? (
                        <Skeleton active />
                    ) : (
                        <>
                            <Form.Item
                                label={<span className='text-fit-red-900 font-semibold'>{displayMessage('TITLE')}:</span>}
                                name="title"
                                className={`w-full m-0`}
                                required
                                rules={[
                                    { required: true, message: displayMessage('TITLE_MANDATORY') },
                                    { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, message: displayMessage('INVALID_INPUT_DATA') },
                                    { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
                                ]}
                                initialValue={""}
                            >
                                <SL_Input type="text" className='text-fit-red-900' />
                            </Form.Item>

                            <Form.Item
                                label={<span className='text-fit-red-900 font-semibold'>{displayMessage('DESCRIPTION')}:</span>}
                                name="description"
                                className={`w-full m-0`}
                                rules={[
                                    { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, message: displayMessage('INVALID_INPUT_DATA') },
                                    { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
                                ]}
                                initialValue={""}
                            >
                                <SL_Input textarea={true} rows={4} showCount maxLength={2000} type="text" className='text-fit-red-900' />
                            </Form.Item>

                            <div className="gap-4 flex w-full flex-col smb:flex-row mt-2">
                                <Form.Item
                                    label={<span className='text-fit-red-900 font-semibold'>{displayMessage('CATEGORY')}:</span>}
                                    name="category_id"
                                    className={`w-full m-0`}
                                    initialValue={null}
                                    required
                                    rules={[{ required: true, message: displayMessage('CATEGORY_MANDATORY') }]}
                                >
                                    <SL_Select onChange={onCategoryChange} options={categories} />
                                </Form.Item>


                                <Form.Item
                                    label={<span className='text-fit-red-900 font-semibold'>{displayMessage('SUBCATEGORY')}:</span>}
                                    name="subcategory_id"
                                    className={`w-full m-0`}
                                    required={subcategories?.length }
                                    rules={[{ required: subcategories?.length, message: displayMessage('SUBCATEGORY_MANDATORY') }]}
                                    initialValue={null}
                                >
                                    <SL_Select disabled={!subcategories?.length} options={subcategories} />
                                </Form.Item>

                              
                            </div>

                            <div className="gap-4 flex w-full flex-col smb:flex-row mt-2">
                                <Form.Item
                                    label={<span className='text-fit-red-900 font-semibold'>{displayMessage('TYPE')}:</span>}
                                    name={"type"}
                                    className={`w-full m-0`}
                                    required
                                    initialValue={EContentTypes.IMAGE.value}
                                >
                                    <SL_Select options={Object.values(EContentTypes).map(({ value, label }) => ({ value, label }))} />
                                </Form.Item>

                                <Form.Item
									label={<span className='text-fit-red-900 font-semibold'>{displayMessage('ORDER_CODE')}:</span>}
									name={"order_code"}
									className={`w-full m-0`}
									required
									initialValue={0}
								>
									<SL_Input type="number" className='text-fit-red-900' />
								</Form.Item>

                              
                            </div>

                            <div style={{ justifyContent: "space-between"}} className="gap-4 flex w-full flex-col smb:flex-row mt-2">
                                <ContentType editorRef={editorRef} type={type} />
                            </div>
                        </>
                    )
                }
            </Form>
        </Modal >
    )
}

function ContentType({ type, editorRef }) {
    //Criado apenas para component não quebrar. Valores estão sendo pegos da ref.
    const [text, setText] = useState('')
    const [isLt5M, setIsLt5M] = useState(true)

    useEffect(() => {
        setText('')
    }, [type])

    function customRequest({ file, onSuccess }) {
        setTimeout(() => {
            onSuccess()
        }, 500)
    }

    function onCheckFileSize(file) {
        // Checa se o tamanho do arquivo é menor que 5 Mb
        const fileSize = file.size / 1024 / 1024 < 5
        setIsLt5M(fileSize)
        if (!fileSize) {
            alert(displayMessage('CONTENT_SIZE_WARNING'))
        }
    }

    if (type == EContentTypes.IMAGE.value) {
        return (
            <>
                <Form.Item
                    label={''}
                    name={"image"}
                    className={`w-full m-0 mt-2`}
                    initialValue={null}
                    required
                >
                    <SL_Upload maxCount={1} listType="picture" customRequest={customRequest} beforeUpload={onCheckFileSize} >
                        <SL_Button icon={<UploadOutlined />}>{displayMessage('LOAD_IMAGE')}</SL_Button>
                    </SL_Upload>
                </Form.Item>
            </>
        )
    }

    if (type == EContentTypes.VIDEO.value) {
        return (
            <>
                <Form.Item
                    label={<span className='text-fit-red-900 font-semibold'>{displayMessage('VIDEO_LINK')}:</span>}
                    name={'video_url'}
                    className={`w-full m-0 mt-2`}
                    initialValue={''}
                    required
                >
                    <SL_Input type={"url"} />
                </Form.Item>
            </>
        )
    }

    if (type == EContentTypes.TEXT.value) {
        return (
            <>
                <div className="overflow-auto w-full mt-2">
                    <div className="min-w-[400px] w-full h-[200px]">
                        <SL_HtmlEditor  ref={editorRef} value={text} onChange={e => { setText(editorRef.current.getEditorInnerHTML()) }} />
                    </div>
                </div>
            </>

        )
    }

    return <></>
}